// Author: T4professor

import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-button-rendererapprove',
    template: `
    <button class="font-sans-3xs usa-button usa-button--accent-warm" [disabled]="isAlreadyApproved"
            (click)="onClick($event)">{{label}}</button>
  `,
    standalone: false
})

export class ButtonRendererApproveComponent implements ICellRendererAngularComp {
  params;
  label: string;
  isAlreadyApproved: boolean;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    if (this.params.node.data?.documentStatus === 'Finalized') this.isAlreadyApproved = true;
    else this.isAlreadyApproved = false;
    if(this.params.node.data.documentType?.includes('TSP Agreement')) this.isAlreadyApproved = true;
  }

  refresh(params?: ICellRendererParams): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    }
  }
}
